export default {
  root: {
    '&$disabled': {
      color: '#444b'
    }
  }
};
